<template>
  <div class="registro-view">

    <!-- APP BAR -->
    <v-toolbar color="transparent" density="compact" flat>
      <v-btn icon @click="$router.push('/')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="text-subtitle-1 font-weight-bold">Regresar</v-toolbar-title>
    </v-toolbar>

    <!-- CONTENIDO PRINCIPAL -->
  <div class="registro-scroll">
<v-container
  fluid
  style="
    min-height: 100%;
    background-image: url('https://mvexpress.mx/api/images/publicidad/patronazul.png');
    background-size: cover;
    background-position: center;
  "
>
      <v-row justify="center" align="center">
        <!-- REGISTRO -->
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card variant="flat" class="mx-auto pa-6" elevation="8" rounded="lg">

            <div class="text-center mb-4">
              <v-img
                src="https://mvexpress.mx/api/images/logosapp/logomv2.png"
                max-width="180"
                contain
                class="mx-auto"
              />
            </div>

            <v-card-title class="text-center">Registro de Clientes</v-card-title>

            <v-card-text>
              <v-form ref="registerForm" v-model="registerValid">

                <v-text-field
                  label="Número de Cliente"
                  v-model="cliente"
                  :rules="[rules.required, rules.clienteSoloNumeros]"
                  prepend-inner-icon="mdi-account"
                />

                <v-text-field
                  label="Correo Electrónico"
                  v-model="email"
                  :rules="[rules.email]"
                  prepend-inner-icon="mdi-email-outline"
                />

                      <v-text-field
                  label="Número de Celular"
                  v-model="telefono"
                  :rules="[rules.required]"
                  prepend-inner-icon="mdi-message-processing"
                />

                <v-radio-group
                  v-model="validationMethod"
                  row
                  class="mt-2"
                  :rules="[rules.required]"
                >
                  <v-radio label="Validar por correo" value="email" />
                  <v-radio disabled label="Validar por SMS" value="sms" />
                </v-radio-group>  

           <v-text-field
  :type="showPassword ? 'text' : 'password'"
  label="Contraseña"
  v-model="password"
  :rules="[rules.required, rules.password]"
  hint="Ejemplo: #Mv@2026."
  persistent-hint
  prepend-inner-icon="mdi-lock-outline"
  :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
  @click:append-inner="showPassword = !showPassword"
/>


                <v-checkbox
                  v-model="isAdult"
                  :rules="[v => v || 'Debes confirmar que eres mayor de 18 años']"
                  label="Confirmo que soy mayor de 18 años"
                  class="mt-4"
                />

           <v-btn
              :disabled="!registerValid || !isAdult || loadingRegister"
              :loading="loadingRegister"
              block
              color="primary"
              class="mt-4"
              size="large"
              @click="register"
            >
              Registrarse
            </v-btn>


              </v-form>

           
            </v-card-text>
           <div class="text-center mt-12 mb-4">
          <span class="text-sm text-black/90">
            © {{ new Date().getFullYear() }} Grupo MV ·
            <a
              href="/aviso-privacidad"
              class="font-medium underline ml-1"
            >
              Aviso de Privacidad
            </a>
          </span>
        </div>
          </v-card>
        </v-col>
      </v-row>

        <!-- Aviso de privacidad -->
   

      </v-container>
    </div>

    <!-- FOOTER -->
    <div class="registro-footer bg-orange d-flex justify-center align-center text-white py-1">
      <span class="text-caption">Versión {{ versionApp }}</span>
    </div>

  </div>
</template>


<style>
.registro-view {
  background-color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.registro-scroll {
  height: calc(100vh - (64px + env(safe-area-inset-top, 30px)) - 48px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: calc(40px + env(safe-area-inset-bottom)); /* Espacio para el footer */
}

.registro-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding-bottom: env(safe-area-inset-bottom, 10px);
  min-height: 30px;
}
</style>

<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {
    components: {  },

  data() {
    return {
        versionApp: "1.0.3",
      loadingRegister: false,
      isAdult: false,
      cliente: "",
      email: "",
      telefono: "",
      password: "",
      validationMethod: "", // <-- email o sms
      registerValid: false,
      showPassword: false,
      rules: {
        required: (v) => !!v || "Este campo es obligatorio.",
        email: (v) => !v || /.+@.+\..+/.test(v) || "Ingrese un correo válido.",
        clienteSoloNumeros: (v) =>
          !v || /^\d+$/.test(String(v)) || "Solo debe contener números.",
      password: (v) =>
   /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&.]{6,}$/.test(v) ||
  "Mínimo 6 caracteres, con letras, números y puede incluir símbolos.",
        otp6: (v) => /^\d{6}$/.test(v) || "El código debe tener 6 dígitos.",
      },
    };
  },
watch: {
  cliente(val) { localStorage.setItem("reg_cliente", val); },
  email(val) { localStorage.setItem("reg_email", val); },
  telefono(val) { localStorage.setItem("reg_phone", val); },
  password(val) { localStorage.setItem("reg_password", val); },
  validationMethod(val) { localStorage.setItem("reg_validationMethod", val); }
},
mounted() {
  this.cliente = localStorage.getItem("reg_cliente") || "";
  this.email = localStorage.getItem("reg_email") || "";
  this.telefono = localStorage.getItem("reg_phone") || "";
  this.password = localStorage.getItem("reg_password") || "";
  this.validationMethod = localStorage.getItem("reg_validationMethod") || "";
},

  methods: {
    async register() {
      const valid = await this.$refs.registerForm.validate();
      if (!valid) return;
      await this.sendRegisterRequest();
    },

clearRegisterData() {
  localStorage.removeItem("reg_cliente");
  localStorage.removeItem("reg_email");
  localStorage.removeItem("reg_phone");
  localStorage.removeItem("reg_password");
  localStorage.removeItem("reg_validationMethod");
},


async sendRegisterRequest() {
  this.loadingRegister = true;

  try {
    const payload = {
      cliente: this.cliente,
      password: this.password,
      telefono: this.telefono,
    };

    if (this.validationMethod === "email") payload.email = this.email;

    const response = await axios.post(
      "https://mvexpress.mx/api/register",
      payload
    );

    console.log(response)
    const msg =
      this.validationMethod === "email"
        ? "Se envió un código de verificación a tu correo."
        : "Se envió un código de verificación a tu celular.";

    // Abrimos el modal de verificación directamente
    this.openVerificationModal();
      console.log(msg);

  } catch (error) {
    this.handleError(error, "Error al registrar");
  } finally {
    this.loadingRegister = false;
  }
},

async openVerificationModal() {
  const result = await Swal.fire({
    title: 'Verificación de cuenta',
    html: `
      <p style="font-size: 0.9rem; color: #666; margin-bottom: 15px;">
        Ingresa el código de 6 dígitos enviado a tu ${this.validationMethod === 'email' ? 'correo' : 'celular'}.
      </p>
      <input id="swal-input-code" type="number" class="swal2-input" placeholder="000000" maxlength="6" 
        style="text-align:center; letter-spacing: 5px; font-size: 1.5rem; width: 200px; margin: 0 auto;">
      
      <div style="margin-top: 20px;">
        <button type="button" id="resend-btn" class="swal2-styled" 
          style="background: transparent; color: #1976D2; border: none; cursor: pointer; font-weight: 600; font-size: 0.9rem;">
          ¿No recibiste el código? Reenviar
        </button>
      </div>
    `,
    allowOutsideClick: false,
    showCancelButton: true,
    confirmButtonText: 'Verificar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#1976D2',
    cancelButtonColor: '#d33',
    didOpen: () => {
      const input = Swal.getPopup().querySelector('#swal-input-code');
      const resendBtn = Swal.getPopup().querySelector('#resend-btn');
      
      if(input) input.focus();
      
      if(resendBtn) {
        resendBtn.addEventListener('click', async () => {
           resendBtn.style.opacity = '0.5';
           resendBtn.style.pointerEvents = 'none';
           resendBtn.innerText = 'Enviando...';
           
           await this.resendCode();
           
           resendBtn.innerText = 'Código reenviado ✅';
           setTimeout(() => {
             resendBtn.innerText = '¿No recibiste el código? Reenviar';
             resendBtn.style.opacity = '1';
             resendBtn.style.pointerEvents = 'auto';
           }, 3000);
        });
      }
    },
    preConfirm: async () => {
      const code = Swal.getPopup().querySelector('#swal-input-code').value;
      if (!code || code.length < 6) {
        Swal.showValidationMessage('Ingresa el código completo');
        return false;
      }
      
      try {
        await this.verifyCodeApi(code);
        return true;
      } catch (error) {
        Swal.showValidationMessage(error.response?.data?.message || 'Código incorrecto');
        return false;
      }
    }
  });

  if (result.isConfirmed) {
     this.showSwal("success", "Verificado", "Tu cuenta ha sido verificada correctamente.");
     this.clearRegisterData();
     this.$router.replace("/Home");
  }
},

async resendCode() {
  try {
    const payload = {
      cliente: this.cliente,
      password: this.password,
      telefono: this.telefono,
    };
    if (this.validationMethod === "email") payload.email = this.email;
    await axios.post("https://mvexpress.mx/api/register", payload);
  } catch (error) {
    console.error("Error reenviando código", error);
  }
},

async verifyCodeApi(code) {
    const payload = { code };
    if (this.validationMethod === "email") payload.email = this.email;
    else payload.telefono = this.telefono;
    await axios.post("https://mvexpress.mx/api/verify-code", payload);
},

    showSwal(icon, title, text) {
      Swal.fire({
        icon,
        title,
        text,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    },

    handleError(error, defaultTitle) {
      const msg =
        error?.response?.data?.message || "No se pudo conectar con el servidor";
      this.showSwal("error", defaultTitle, msg);
      console.log(msg);
    },
  },
};
</script>
